module.exports = __webpack_public_path__ + "static/media/7.951b495a.jpg";